// src/pages/Home.js - UPDATED WITH SCROLL LOCK
import React, { useState, useEffect } from 'react';
import Header from "../../components/header";
import Footer from "../../components/footer";
import DangerZoneMap from "../../components/DangerZoneMap";
import IncidentSidebar from "../../components/IncidentSidebar";

function Home() {
  const [activeTab, setActiveTab] = useState('feed');
  const [selectedIncident, setSelectedIncident] = useState(null);
  const [theme, setTheme] = useState('dark');
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // Load theme and set initial sidebar state
  useEffect(() => {
    const savedTheme = localStorage.getItem('sety-theme') || 'dark';
    setTheme(savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);
    
    // Set sidebar state based on screen size
    const isMobile = window.innerWidth < 768;
    setIsSidebarOpen(!isMobile); // Open on desktop, closed on mobile
  }, []);

  // Handle body scroll lock on mobile when sidebar is open
  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    
    if (isMobile) {
      if (isSidebarOpen) {
        document.body.classList.add('sidebar-open');
      } else {
        document.body.classList.remove('sidebar-open');
      }
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('sidebar-open');
    };
  }, [isSidebarOpen]);

  // Toggle theme
  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('sety-theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  };

  // Handle incident selection from map or sidebar
  const handleIncidentSelect = (incident) => {
    setSelectedIncident(incident);
    setActiveTab('feed');
    
    // On mobile, open sidebar when incident selected from map
    // const isMobile = window.innerWidth < 768;
    // if (isMobile) {
    //   setIsSidebarOpen(true);
    // }
  };

  // Toggle mobile sidebar
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="sety-dashboard">
      <Header 
        on={'home'} 
        theme={theme} 
        onThemeToggle={toggleTheme}
        onMobileSidebarToggle={toggleSidebar}
        showMobileToggle={true}
      />

      <main className="dashboard-viewport">
        {/* SIDEBAR ON LEFT (Desktop) / Full Screen Overlay (Mobile) */}
        <aside className={`intel-panel ${isSidebarOpen ? 'open' : ''}`}>
          {/* Mobile Close Button */}
          <button 
            className="mobile-close-btn"
            onClick={toggleSidebar}
            aria-label="Close sidebar"
          >
            <i className="fa-solid fa-xmark"></i>
          </button>

          <div className="panel-header">
            <div className="tab-switcher">
              <button 
                className={activeTab === 'feed' ? 'active' : ''} 
                onClick={() => setActiveTab('feed')}
                aria-label="View live intelligence feed"
              >
                <i className="fa-solid fa-tower-broadcast"></i>
                <span>Live Intel</span>
              </button>
              <button 
                className={activeTab === 'predict' ? 'active' : ''} 
                onClick={() => setActiveTab('predict')}
                aria-label="View AI predictions"
              >
                <i className="fa-solid fa-brain"></i>
                <span>AI Predict</span>
              </button>
              <button 
                className={activeTab === 'report' ? 'active' : ''} 
                onClick={() => setActiveTab('report')}
                aria-label="Report an incident"
              >
                <i className="fa-solid fa-bullhorn"></i>
                <span>Report</span>
              </button>
            </div>
          </div>

          <div className="panel-body">
            <IncidentSidebar 
              mode={activeTab} 
              selectedIncident={selectedIncident}
              onIncidentSelect={handleIncidentSelect}
              toggleSidebar = {toggleSidebar}
            />
          </div>
        </aside>

        {/* MAP ON RIGHT (Desktop) / Full Screen (Mobile when sidebar closed) */}
        <div className="map-canvas">
          <DangerZoneMap 
            onIncidentSelect={handleIncidentSelect}
            selectedIncident={selectedIncident}
            theme={theme}
          />
          
          {/* FLOATING MAP CONTROLS */}
          <div className="map-overlay-tools">
            <button 
              className="tool-btn" 
              title="Toggle Theme"
              aria-label="Toggle dark/light mode"
              onClick={toggleTheme}
            >
              <i className={`fa-solid fa-${theme === 'dark' ? 'sun' : 'moon'}`}></i>
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Home;